import { Div, Button, Span } from "@tblabs/truffle";
import { ContextMenu } from "./Utils/Menu";
import { AuthService } from "../Services/Auth/AuthService";
import { Router } from "../Services/Router";
import { Svg } from "./Utils/Svg";
import { Icons } from "./Utils/Icons";
import { XPrimaryButton, XSecondaryButton } from "./Utils/XPrimaryButton";


export class TopPanel extends Div
{
    constructor(_router: Router, _auth: AuthService)
    {
        super("header");

        this.Append(
            new Div("header__container").Append(
                new Div("header__content").Append(
                    new Div("header__buttons").Append(
                        new XSecondaryButton("Wszystkie zamówienia", Icons.List).OnClick(() => _router.GoToOrdersList()),
                        new XPrimaryButton("Dodaj", Icons.Plus).OnClick(() => _router.GoToOrderCreate())
                    ),
                    new Div("user-section").Append(
                        new ContextMenu(
                            _auth.IsAuthorized
                                ? { 
                                    "Wyloguj": () => { _auth.Logout(); _router.GoToLogin(); window.location.reload(); },
                                    "Wydatki": () => _router.GoToExpenses(),
                                    "Agenci": () => _router.GoToAgentsPage()
                                }
                                : { "Zaloguj": () => _router.GoToLogin() },
                            new Div("user-section__avatar").Text(_auth.UserInfo?.User?.Icon || "🙂")
                        ),
                        new Div("user-section__info").Append(
                            new Span(_auth.UserInfo?.User?.Name || "Niezalogowany").Class("user-section__name"),
                            new Span(!!_auth.UserInfo ? _auth.UserInfo.User.Role : "Niezalogowany").Class("user-section__role")
                        )
                    )
                )
            )
        );
    }
}
